export default function interpolate(value: number): number {
  return (value * (100 - 10)) / 100 + 10;
}
